import { z } from 'zod'

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
] as const
export const ALLOWED_AUDIO_TYPES = [
  'audio/webm',
  'audio/mp4',
  'audio/aac',
  'audio/mpeg',
  'audio/ogg',
] as const
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024
/** Voice notes are short (60 s max in the app); this is a generous ceiling. */
export const MAX_VOICE_NOTE_SECONDS = 120

export const UploadContentType = z.enum([...ALLOWED_IMAGE_TYPES, ...ALLOWED_AUDIO_TYPES])
export type UploadContentType = z.infer<typeof UploadContentType>

export const PresignBody = z.object({
  content_type: UploadContentType,
  size: z.number().int().positive().max(MAX_UPLOAD_BYTES),
  /**
   * Chosen by the device for uploads that may be retried (offline captures):
   * the same id always maps to the same object key, so a retry cannot
   * create a second photo.
   */
  upload_id: z.uuid().optional(),
})
export type PresignBody = z.infer<typeof PresignBody>

export const PresignResponse = z.object({
  object_key: z.string(),
  upload_url: z.url(),
  expires_in: z.number().int(),
  headers: z.record(z.string(), z.string()),
})
export type PresignResponse = z.infer<typeof PresignResponse>
